// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-entrance .component-section .input[data-v-6517ddb6]:not(:first-child) {
  margin-top: 10%;
}
.login-entrance .component-section #login-btn[data-v-6517ddb6] {
  margin-top: 14%;
}
.login-entrance .component-section .disable[data-v-6517ddb6] {
  background: var(--login-btns-bgcolor) !important;
}
.login-entrance .component-section .input-block[data-v-6517ddb6] {
  padding-top: 15%;
}
.login-entrance .custom-input-text[data-v-6517ddb6] {
  max-width: 196px;
}
.login-entrance .password-section[data-v-6517ddb6] {
  display: flex;
  margin-top: 10%;
}
.login-entrance .password-section i[data-v-6517ddb6] {
  cursor: pointer;
  align-self: center;
  font-size: 18px;
  color: var(--login-color);
}
.login-entrance .oauth2-section + .oauth2-section[data-v-6517ddb6] {
  margin-top: 10px;
}
.login-entrance .oauth2-section .alt-entrace-btns[data-v-6517ddb6] {
  display: flex;
  width: fit-content;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin-top: -5%;
  margin-bottom: 10%;
}
.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn[data-v-6517ddb6] {
  height: 44px;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: var(--login-color);
  background-color: var(--login-btns-bgcolor);
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  padding: 0 8px;
  margin-top: 12px;
}
.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn img[data-v-6517ddb6] {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}
.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn span[data-v-6517ddb6] {
  text-align: center;
  flex: 1;
}
.login-entrance .component-footer[data-v-6517ddb6] {
  display: flex;
  flex-direction: column;
}
.login-entrance .component-footer .pass-restore-block[data-v-6517ddb6],
.login-entrance .component-footer .registration-block[data-v-6517ddb6] {
  font-size: 15px;
  margin-top: 5%;
  margin-bottom: 10%;
  margin-left: auto;
  margin-right: auto;
}
.login-entrance .component-footer .pass-restore-block a[data-v-6517ddb6],
.login-entrance .component-footer .registration-block a[data-v-6517ddb6] {
  color: var(--login-color);
  cursor: pointer;
}
.login-entrance .component-footer .pass-restore-block a[data-v-6517ddb6]:focus,
.login-entrance .component-footer .registration-block a[data-v-6517ddb6]:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/login/LoginPass.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,aAAa;AACf","sourcesContent":[".login-entrance .component-section .input[data-v-6517ddb6]:not(:first-child) {\n  margin-top: 10%;\n}\n.login-entrance .component-section #login-btn[data-v-6517ddb6] {\n  margin-top: 14%;\n}\n.login-entrance .component-section .disable[data-v-6517ddb6] {\n  background: var(--login-btns-bgcolor) !important;\n}\n.login-entrance .component-section .input-block[data-v-6517ddb6] {\n  padding-top: 15%;\n}\n.login-entrance .custom-input-text[data-v-6517ddb6] {\n  max-width: 196px;\n}\n.login-entrance .password-section[data-v-6517ddb6] {\n  display: flex;\n  margin-top: 10%;\n}\n.login-entrance .password-section i[data-v-6517ddb6] {\n  cursor: pointer;\n  align-self: center;\n  font-size: 18px;\n  color: var(--login-color);\n}\n.login-entrance .oauth2-section + .oauth2-section[data-v-6517ddb6] {\n  margin-top: 10px;\n}\n.login-entrance .oauth2-section .alt-entrace-btns[data-v-6517ddb6] {\n  display: flex;\n  width: fit-content;\n  position: relative;\n  left: 50%;\n  transform: translate(-50%, 0);\n  margin-top: -5%;\n  margin-bottom: 10%;\n}\n.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn[data-v-6517ddb6] {\n  height: 44px;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: var(--login-color);\n  background-color: var(--login-btns-bgcolor);\n  border-radius: 5px;\n  cursor: pointer;\n  white-space: nowrap;\n  width: 100%;\n  padding: 0 8px;\n  margin-top: 12px;\n}\n.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn img[data-v-6517ddb6] {\n  width: 24px;\n  height: 24px;\n  margin-right: 5px;\n}\n.login-entrance .oauth2-section .alt-entrace-btns .alt-entrace-btn span[data-v-6517ddb6] {\n  text-align: center;\n  flex: 1;\n}\n.login-entrance .component-footer[data-v-6517ddb6] {\n  display: flex;\n  flex-direction: column;\n}\n.login-entrance .component-footer .pass-restore-block[data-v-6517ddb6],\n.login-entrance .component-footer .registration-block[data-v-6517ddb6] {\n  font-size: 15px;\n  margin-top: 5%;\n  margin-bottom: 10%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.login-entrance .component-footer .pass-restore-block a[data-v-6517ddb6],\n.login-entrance .component-footer .registration-block a[data-v-6517ddb6] {\n  color: var(--login-color);\n  cursor: pointer;\n}\n.login-entrance .component-footer .pass-restore-block a[data-v-6517ddb6]:focus,\n.login-entrance .component-footer .registration-block a[data-v-6517ddb6]:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
